import React, { createContext, createElement, isValidElement, cloneElement } from 'react';
import { compose, setDisplayName } from 'recompose';

var HeadingSectionContext = createContext(null);
var Provider = HeadingSectionContext.Provider,
    Consumer = HeadingSectionContext.Consumer;

var HeadingRoot = function HeadingRoot(_ref) {
  var children = _ref.children;
  return React.createElement(Provider, {
    value: 0
  }, children);
};
var enhance = compose(setDisplayName('HeadingRoot'));
var HeadingRoot$1 = enhance(HeadingRoot);

var HeadingSection = function HeadingSection(_ref) {
  var children = _ref.children;
  return React.createElement(Consumer, null, function (depth) {
    return React.createElement(Provider, {
      value: depth + 1
    }, children);
  });
};
var enhance$1 = compose(setDisplayName('HeadingSection'));
var HeadingSection$1 = enhance$1(HeadingSection);

var Heading = function Heading(_ref) {
  var component = _ref.component;
  return React.createElement(Consumer, null, function (depth) {
    if (typeof component === 'string') {
      return createElement(component, {});
    }

    if (isValidElement(component)) {
      return cloneElement(component, {
        depth: depth
      });
    }

    return createElement(component, {
      depth: depth
    });
  });
};
var enhance$2 = compose(setDisplayName('Heading'));
var Heading$1 = enhance$2(Heading);

var findClosestDepth = function findClosestDepth(props) {
  var depth = props.depth; // eslint-disable-next-line

  for (var i = depth; i > 0; i -= 1) {
    var h = props["h".concat(i)];

    if (h != null) {
      return h;
    }
  } // eslint-disable-next-line fp/no-nil


  return null;
};

var HeadingMatrix = findClosestDepth;
var enhance$3 = compose(setDisplayName('HeadingMatrix'));
var HeadingMatrix$1 = enhance$3(HeadingMatrix);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var H = function H(_ref) {
  var depth = _ref.depth,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["depth", "children"]);

  return createElement("h".concat(depth), rest, children);
};
var enhance$4 = compose(setDisplayName('H'));
var H$1 = enhance$4(H);

export { H$1 as H, Heading$1 as Heading, HeadingMatrix$1 as HeadingMatrix, HeadingRoot$1 as HeadingRoot, HeadingSection$1 as HeadingSection };
